import React, { useState } from "react";
import { navigate } from "vike/client/router";
import { data } from "./data";
import { AppShell, Avatar, Text, Button, Menu } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconInfoCircle, IconChevronRight } from "@tabler/icons-react";
import { userAtom } from "#root/atoms/userAtom";
import { useAtomValue } from "jotai";

const FixHeader = ({ toggle }: { toggle: () => void }) => {
  const [openedMenu, setOpenedMenu] = useState(false);
  const user = useAtomValue(userAtom);

  const handleClick = async () => {
    if (!user) {
      const navigationPromise = navigate("/login");
      await navigationPromise;

      showNotification({
        title: "You are not connected",
        message: "Please login or create an account.",
        icon: <IconInfoCircle />,
      });
      toggle();
      return;
    }
    setOpenedMenu((o) => !o);
  };

  return (
    <>
      <AppShell.Section aria-label="User account menu">
        <Menu
          shadow="md"
          position="bottom-start"
          withinPortal
          trapFocus
          aria-label="User actions dropdown"
          width={200}
          //  ⚠️⚠️⚠️ Open if authorized; otherwise, keep it closed
          opened={user ? openedMenu : false}
          // opened={opened} // ⚠️⚠️⚠️ Always show the menu regardless of authorization
          onChange={setOpenedMenu}
        >
          <Menu.Target>
            <Button
              disabled={!user}
              loaderProps={{ type: "dots" }}
              variant="subtle"
              leftSection={
                <Avatar
                  key={user?.user_metadata?.avatar_url}
                  src={user?.user_metadata?.avatar_url}
                  alt="User avatar"
                  color="blue"
                  radius="xl"
                />
              }
              rightSection={<IconChevronRight size={24} />}
              size="lg"
              component="a"
              role="button"
              aria-haspopup="menu"
              aria-label="Open user menu"
              onClick={handleClick}
              fullWidth
              justify="start"
            >
              <Text truncate="end" size="md" fw={500}>
                {user?.user_metadata?.username ?? "Hello"}
              </Text>
            </Button>
          </Menu.Target>

          <Menu.Dropdown>
            {data.sections.map((section, index) => (
              <React.Fragment key={index}>
                <Menu.Label>{section.label}</Menu.Label>
                {section.items.map((item, idx) => (
                  <Menu.Item
                    key={idx}
                    leftSection={<item.icon size={20} />}
                    component="a"
                    href={item.href}
                    color={item.danger ? "red" : undefined}
                    aria-label={item.label}
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {item.label}
                  </Menu.Item>
                ))}
                {index !== data.sections.length - 1 && <Menu.Divider />}
              </React.Fragment>
            ))}
          </Menu.Dropdown>
          <Menu.Divider />
        </Menu>
      </AppShell.Section>
    </>
  );
};

export default FixHeader;
